import { useEffect, useState } from "react";

export function FunnelProgress({ value }) {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => setProgress(value));
    return () => window.cancelAnimationFrame(frame);
  }, [value]);
  return <div className="funnel-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow={value} aria-label={`${value}% complete`} data-testid={`funnel-progress-${value}`}><span className="funnel-progress-fill" style={{ width: `${progress}%` }} /></div>;
}
